
<div mat-dialog-title>Import Equivalents<button class="close" mat-button title="Cancel" (click)="close()"><i class="material-icons clear" >clear</i></button></div>
<mat-dialog-content>
  @if (hasFile && !isValidFile) {
    <mat-card class="error block">
      <mat-card-title class="error">{{invalidFileErrorHeader}}</mat-card-title>
      <mat-card-subtitle>{{invalidFileErrorMessage}}</mat-card-subtitle>
    </mat-card>
  }
  @if (errorMessage) {
    <mat-card class="error block">
      <mat-card-title class="error">An error occurred.</mat-card-title>
      <mat-card-subtitle>{{errorMessage}}</mat-card-subtitle>
    </mat-card>
  }
  <div>Import security and custom category equivalents.</div>
  <div>
    <table class="import" style="width:100%;">
      <tr>
        <th style="vertical-align: top;text-align: left;"><label>File name</label></th>
        <td>
          <div class="bottomPaddingElementDialog">
            <irb-file-selector (change)="onFileChange($event)"></irb-file-selector>
            <div>File type must be .csv</div>
          </div>
        </td>
      </tr>
      <tr>
        <th style="vertical-align: top;text-align: left;"><label>Instructions</label></th>
        <td><div class="block">Your selected file must be in .csv format and follow iRebal's format: Symbol/CUSIP, Equivalent Symbol/CUSIP, Alt if Held, Equivalent Custom Category</div></td>
      </tr>
      <tr>
        <th style="vertical-align: top;text-align: left;"><label>Template</label></th>
        <td>
          <div>Use our .csv template to prepare your file.<br/>
            <a href="/assets/template/Equivalents.xlsx">Download template: Equivalents.xlsx</a></div>
          </td>
        </tr>
      </table>
    </div>

  </mat-dialog-content>
  <mat-dialog-actions>
    <button (click)="close()" class="btn-medium-secondary" id="closeButton">Cancel</button>
    <button (click)="submitFile()" [disabled]="!(hasFile && isValidFile && !errorMessage)" class="btn-medium-primary"
      id="continueButton">Continue
    </button>
  </mat-dialog-actions>
